/**
 * GuidedCreateModal — the "Create a book with AI" flow, presented in place.
 *
 * Desktop → centered Dialog; Mobile → bottom Drawer. Hosts the full guided
 * wizard (idea → outline → bible → drafts) without leaving the current screen.
 * Content-sized with an internal scroll that only kicks in past the screen.
 */

import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '../lib/utils';
import { Drawer, DrawerContent, DrawerTitle } from './ui/drawer';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { GuidedCreateView } from './guided-create-view';

interface GuidedCreateModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function GuidedCreateModal({ open, onOpenChange }: GuidedCreateModalProps) {
  const isMobile = useIsMobile();

  const body = (
    <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
      <GuidedCreateView onClose={() => onOpenChange(false)} />
    </div>
  );

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange} direction="bottom">
        <DrawerContent className={cn('flex max-h-[90dvh] flex-col border-border bg-card text-card-foreground')}>
          <DrawerTitle className="sr-only">Criar livro com IA</DrawerTitle>
          {body}
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton
        className={cn(
          'flex max-h-[90vh] w-full flex-col gap-0 overflow-hidden border-border bg-card p-0 text-card-foreground',
          'sm:max-w-3xl',
        )}
      >
        <DialogTitle className="sr-only">Criar livro com IA</DialogTitle>
        {body}
      </DialogContent>
    </Dialog>
  );
}
